// src/config/seo.js
export const SEO_CONFIG = {
  // Agent Information
  AGENT_NAME: "Andy Osburn",
  AGENT_EMAIL: "osburnandy@gmail.com", 
  AGENT_PHONE: "+1-918-398-3660",
  
  // Business Address
  STREET_ADDRESS: "",
  CITY: "Tulsa",
  STATE: "OK",
  ZIP_CODE: "74107", 
  COUNTRY: "US",
  
  // Geographic Coordinates
  LATITUDE: "36.1540",
  LONGITUDE: "-95.9928",
  
  // Domain & URLs
  DOMAIN: "https://trescollc.com",
  
  // Social Media
  FACEBOOK_URL: "https://www.facebook.com/andyosburn0329/",
  TWITTER_HANDLE: "",
  LINKEDIN_URL: "https://www.linkedin.com/in/andy-osburn-1b31a072/",
  
  // Images  
  OG_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/a.osburn.tulsa_83f6d352fdda4d9b8cb1615a19b9d607.jpg",
  TWITTER_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/a.osburn.tulsa_83f6d352fdda4d9b8cb1615a19b9d607.jpg",
  LOGO_URL: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/a.osburn.tulsa_83f6d352fdda4d9b8cb1615a19b9d607.jpg"
};
